import Image, { ImageProps } from 'next/image'
import React, { FC } from 'react'

import cx from 'classnames'

import { Box } from '@material-ui/core'
import { BoxProps } from '@material-ui/core/Box'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import ContainerFull from '../layouts/ContainerFull'

type StyleProps = {
  darkness?: boolean
  height: number | string
}

const useStyles = makeStyles(
  () =>
    createStyles({
      root: {},
      hero: {
        height: (props: StyleProps) => props.height || 350
      },
      heroImage: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        '&::after': {
          position: 'absolute',
          content: "''",
          zIndex: 1,
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          background: (props: StyleProps) =>
            props.darkness &&
            'linear-gradient(180deg, rgba(35, 35, 35, 0.3) 0%, rgba(35, 35, 35, 0.6) 100%)'
        }
      }
    }),
  { name: 'HeroSection' }
)

interface HeroSectionProps extends BoxProps {
  src: string
  alt?: string
  darkness?: boolean
  placeholderImage?: ImageProps['placeholder']
  sizes?: ImageProps['sizes']
}

const HeroSection: FC<HeroSectionProps> = ({
  src,
  children,
  height = 350,
  darkness,
  className,
  alt,
  placeholderImage,
  sizes,
  ...rest
}) => {
  const classes = useStyles({ height, darkness })

  return (
    <Box
      position="relative"
      zIndex={0}
      className={cx([classes.root, className])}
      {...rest}
    >
      <ContainerFull style={{ zIndex: -1 }}>
        <Box
          className={classes.heroImage}
          height={height}
          width="100%"
          position="relative"
        >
          {src && (
            <Image
              src={src}
              layout="fill"
              alt={alt || 'Hero image'}
              objectFit="cover"
              placeholder={placeholderImage || 'blur'}
              objectPosition="center"
              priority
              loading="eager"
              {...(!!sizes && { sizes })}
            />
          )}
        </Box>
      </ContainerFull>
      <Box
        className={classes.hero}
        zIndex={10}
        display="flex"
        flexDirection="column"
      >
        {children}
      </Box>
    </Box>
  )
}

export default HeroSection
